export default {
  events: {},
  purchasedEvents: [],
}